export const MessageCostsEndpoints = {
  GET_MESSAGE_COST_SUMMARY: (workspaceId: string) => `/message-costs/summary/?workspace_id=${workspaceId}`,
};
